import { useDispatch, useSelector } from 'react-redux'
import { setPriceAdjustDialog } from '../../ActionCreators'
import TipEntryModal from '../../../components/TipEntryModal'
import { getPriceAdjustmentDialog, getCurrentPriceAdjustment } from '../../Selectors'
import { setManagerApprovalPrompt } from '../../../VNManagerApproval/ActionCreators'

const VNPriceAdjustmentDialog = () => {
  const dispatch = useDispatch()
  const isOpen = useSelector(getPriceAdjustmentDialog)
  const priceAdjustmentInCents = useSelector(getCurrentPriceAdjustment)

  if (!isOpen) {
    return null
  }

  return (
    <TipEntryModal
      key="custom"
      title="Price Adjustment"
      saveButtonText="Adjust"
      initialValue={priceAdjustmentInCents}
      onClose={() => {
        dispatch(setPriceAdjustDialog(false))
      }}
      onSubmit={(priceInCents) => {
        dispatch(setPriceAdjustDialog(false))
        const onSuccess = () => {
          dispatch(setPriceAdjustDialog(false, null, priceInCents))
        }
        dispatch(setManagerApprovalPrompt({ onSuccess, buttonText: 'Adjust Price' }))
      }}
      preselected={true}
    />
  )
}

export default VNPriceAdjustmentDialog
